import React, { Component } from 'react'
import { connect } from "react-redux"
import { compose } from "recompose"

import { withStyles } from '@material-ui/core/styles';
import {
	Grid,
	Typography,
	Button
} from "@material-ui/core";

import DataTable from "../../reusable/DataTable"

import noData from "../../../image/no-data.svg"
import columns from "./config/bookTableConfig";
import BookModel from "../../../model/Book";
import Dispatch from "../../../constant/dispatch";


const styles = theme => ({
	root: {
		display: 'flex',
	},
});

class Book extends Component {

	constructor(props) {
		super(props)

		// if(!this.props.isBookDataLoaded) {
		this.props.getBooksData(this.props.currentEvent.id)
		// }
	}

	render() {
		const { classes, books } = this.props
		console.log("Render book")
		return <div className={classes.root}>
			{
				books.length === 0 ? <Grid
					container
					spacing={0}
					direction="column"
					alignItems="center"
					justify="center"
					style={{ minHeight: '80vh' }}>
					<Grid item xs={3} style={{ flexBasis: '0%' }}>
						<img src={noData} height={100} style={{marginBottom: "10px"}}/>
					</Grid>
					<Grid item xs={3} style={{ flexBasis: '0%' }}>
						<Typography color="textSecondary">
							You have no books yet.
						</Typography>
					</Grid>
					<Grid item xs={"auto"} style={{ flexBasis: '0%' }}>
						<Button
							color="primary"
							className={classes.button}
							onClick={() => this.props.openViewBookDialog(new BookModel(this.props.currentEvent.id))}>
							CREATE BOOK
						</Button>
					</Grid>
				</Grid> : <DataTable
					title="Books"
					selectableRows="multiple"
					filter={false}
					viewColumns={true}
					data={books}
					columns={columns}
					createNew={() => this.props.openViewBookDialog(new BookModel(this.props.currentEvent.id))}
					onRowsDelete={book => this.props.deleteBook(book)} />
			}
		</div>
	}
}

const mapStateToProps = function(storage) {
	return {
		currentEvent: storage.eventManager.currentEvent,
		books: storage.book.books,
		isBookDataLoaded: storage.booth.isBookDataLoaded
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		openViewBookDialog: book => dispatch({
			type: Dispatch.OPEN_VIEW_BOOK_DIALOG,
			payload: book
		}),
		getBooksData: eventId => dispatch({
			type: Dispatch.ON_GET_BOOKS_REQUEST,
			payload: eventId
		}),
		deleteBook: book => dispatch({
			type: Dispatch.ON_DELETE_BOOK_BY_ID_REQUEST,
			payload: book
		})
	}
}

export default compose(
	connect(
		mapStateToProps,
		mapDispatchToProps,
	),
	withStyles(styles)
)(Book)
